<template>
    <div class="order-list-page">
        <div class="pageCenter">
            <div class="page-title">
                <router-link class="text1" to="/">首页</router-link> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">商品列表</span> 
            </div>
            <div class="searchTop">
                <div class="oneLine">
                    <div class="myLabel">模 式：</div>
                    <div class="selectItemBox">
                        <div class="oneItem" @click="toggleType(-1)" :class="{active:search_type==-1}">全部</div>
                        <div class="oneItem" @click="toggleType(1)" :class="{active:search_type==1}">花型区</div>
                        <div class="oneItem"  @click="toggleType(0)" :class="{active:search_type==0}">加工区</div>
                    </div>
                </div>
                <div class="oneLine">
                    <div class="myLabel">权 限：</div>
                    <div class="selectItemBox">
                        <!-- <div class="oneItem">全部</div> -->
                        <div class="oneItem active">公开区</div>
                    </div>
                </div>
                
            </div>
            <!-- <div class="searchWrap">
                <div class="oneSelect">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <span class="labelText">筛选条件1</span>
                        <i class="el-icon-arrow-down el-icon-caret-bottom"></i>
                      </span>
                      <el-dropdown-menu>
                        <el-dropdown-item>选项一</el-dropdown-item>
                        <el-dropdown-item disabled>选项一</el-dropdown-item>
                        <el-dropdown-item divided>选项一</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="oneSelect" v-for="list in [1,2,3,4,5]">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <span class="labelText">筛选条件2</span>
                        <i class="el-icon-arrow-down el-icon-caret-bottom"></i>
                      </span>
                      <el-dropdown-menu>
                        <el-dropdown-item>选项一</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div> -->
            <div class="tableWrap">
                <div class="oneListItem" v-for="(list,index) in tableData" @click="toDetail(list)" :key="index">
                    <div class="imgBox">
                        <el-image class="listImg"  :src="IMG_PREV+list.image_file"  fit="cover"></el-image>
                        <div class="tagBox">
                            <p class="flowerTag blueTypeTag" v-if="list.type==1">花型</p>
                            <p class="flowerTag orangeTypeTag" v-if="list.type==0">加工</p>
                            <p class="flowerTag greenTypeTag">公开</p>
                        </div>
                    </div>
                    <div class="titleLine" :class="{oneLineHeight: true}">{{list.title}}</div>
                    <div class="subLine">{{list.flowerName}}</div>
                    <div class="priceLine">
                        <span style="margin-right: 6px">价格 </span>
                        
                        <span class="moneyIcon"> ¥ </span>
                        <span class="moneyNumber">{{list.price}}</span>
                    </div>
                </div>
            </div>
            
            <div class="paginationWrap">
                <div class="totalBox">
                    共 <span class="num">{{total}}</span> 件商品
                </div>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[40, 80, 120]"
                  :page-size="showCount"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  background
                >
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImgUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import {ufunction} from '@/utils/tools'
    export default {
        computed: {
            ...mapGetters([
                'userId'
            ])
        },
        data() {
            return {
                uploadApi: api.uploadfilebatch,
                isLoading:false,
                
                search_type:'',
                search_status:'',
                search_sort:'',
                tableData: [],
                // 分页
                currentPage:1,
                showCount:'',
                total:0,
                order_type_word:[],
                order_status_word:[],
                order_sort_word:[],
                
                // 预览图片
                dialogImgUrl: '',
                dialogImgVisible: false,
            }
        },
        watch: {
            '$route': {
                handler: function(route) {
                    this.showCount = Number(this.$route.query.size) ? Number(this.$route.query.size) : 40
                    this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                    let type = -1
                    if (this.$route.query.type == 1 || this.$route.query.type === 0 || this.$route.query.type === '0') {
                        type = this.$route.query.type
                    }
                    this.search_type = type
                    this.getTableData();
                },
                immediate: true
            }
        },
        created() {
            // this.getTableData()
            this.initWordData()
        },
        computed: {
            ...mapGetters([
                'userId', 'token', 'phone', 'userInfo'
            ]),
            api() {
                return api
            },
            IMG_PREV() {
                return api.imgPrev
            },
        },
        methods: {
            toggleType(arg){
                this.search_type = arg
                this.handleCurrentChange(1)
                
            },
            // 图片预览
            handleImgPreview(url) {
                this.dialogImgUrl = url;
                this.dialogImgVisible = true;
            },
            initWordData(){
                let wordData=ufunction.wordData
                this.order_type_word=JSON.parse(JSON.stringify(wordData.order_type))
                this.order_type_word.unshift({
                    value:'',
                    text:"全部类型"
                })
                this.order_status_word=JSON.parse(JSON.stringify(wordData.order_status))
                this.order_status_word.unshift({
                    value:'',
                    text:"全部状态"
                })
                this.order_sort_word=wordData.order_sort
            },
            toDetail(list) {
                console.log(list)
                if(list.type==0){//加工
                    this.$router.push({
                        path: 'fabricDetail',
                        query: {
                            id: list.id,
                            type: list.type,
                        }
                    })
                }
                if(list.type==1){//花型
                    this.$router.push({
                        path: 'flowerDetail',
                        query: {
                            id: list.id,
                            type: list.type,
                        }
                    })
                }
                
            },
            handleSizeChange(val) {
                this.showCount = val
                this.currentPage = 1
                this.curRoutePush()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.curRoutePush()
            },
            curRoutePush() {
                this.$router.push('/fabric'+
                '?page=' + this.currentPage + 
                '&size=' + this.showCount+
                '&type=' + this.search_type
                ).catch(err => {
                    err
                })
            },
            getTableData() {
                let _this = this
                _this.isLoading=true
                let arg = {
                    // currentResult:_this.currentPage,// parseInt(_this.showCount) * (parseInt(_this.currentPage) - 1),//起始查询条数
                    // orderByType: this.search_sort,
                    // orderStatus: this.search_status,
                    // orderType: this.search_type ,
                    // showCount: this.showCount,//相当于pageSize
                    // token: this.token,
                    // userId: this.userId,
                    page:this.currentPage,
                    size:this.showCount,
                    type:this.search_type // -1 全部， 0 是加工，1是花型
                }
                console.log(arg,"查询的参数")
                request({
                    url: api.getBJYList, 
                    data: arg
                }).then(res => {
                    _this.isLoading=false
                    if(res.errorCode==200){
                        _this.tableData = res.data.bjyList.map(function(item,index){
                                
                            item.image_file=item.flowerPic.replace("/share","")
                            // 价格 两种情况
                            try{
                                let price1=JSON.parse(item.rawDataStr).prices[0].content 
                                item.price=price1
                            }catch(e){
                            }
                            try{
                                let price2=JSON.parse(item.prices)[0].content
                                item.price=price2
                            }catch(e){
                            }
                            
                            try{
                                let typeList = JSON.parse(item.typeList)
                                // console.log(item.typeList)
                                let detailTitle = ''
                                typeList.forEach(a => {
                                    console.log(a)
                                    a.detailList.forEach(b => {
                                        detailTitle += ' ' + b.name
                                    })
                                });
                                item.title = detailTitle
                            }catch(e){
                                
                            }
                            return item
                        })
                        _this.total=res.data.totalCount
                    }else{
                        _this.tableData =[]
                        _this.total=0
                    }
                    
                }).catch(err => {
                    console.log(err)
                    _this.isLoading=false
                })
            }

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .order-list-page{
         background-color: #fff;;
        .pageCenter{width: 1194px;margin:0 auto;}
        .paginationWrap{padding:15px 0px 55px;text-align: right;
            position:relative;
            .totalBox{
                position: absolute;
                left:0;
                font-size: 12px;
                font-weight: 500;
                color: #4A5B6D;
                line-height: 18px;
                top:22px;
                .num{color:#2A2E3F;}
            }
        }
    }
    
    .searchTop{
        .oneLine{
            margin-bottom: 16px;;
            .myLabel{
                display: inline-block; margin-right: 33px;  //50-17=33px
                font-size: 14px; 
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 20px;
            }
            .selectItemBox{
                display: inline-block;
                .oneItem{
                    cursor: pointer;
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);
                    line-height: 20px;
                    border-radius: 2px; padding:8px 0px ; width: 76px;text-align: center; margin-right: 16px;
                }
                .oneItem:hover{background: #eee;}
                .oneItem.active{background: rgba(63, 51, 255, 0.14);
                    color: #3F33FF;
                }
            }
        }
        
        
    }
    .searchWrap{
        margin-top:24px;
        border-top:1px solid rgba(0,0,0,0.06);
        padding:23px 0 24px;
        .oneSelect{
            display: inline-block;margin-right: 32px;
        }
        .el-select{margin-left:24px;width: 170px;border:1px solid blue;}
    }
    .el-dropdown-link {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
        .labelText{ margin-right: 8px;}
        cursor: pointer;
    }
    .el-dropdown-link:hover{
        color:#3F33FF;
    }
    .el-icon-arrow-down {
    }
    .tableWrap{
        padding-top:20px;
        width:1200px ;
        .oneListItem:nth-child(4n+4) {
           margin-right: 0px !important;
        }
       .oneListItem:hover{cursor: pointer;box-shadow: 3px 3px 16px  #eee;}
        .oneListItem{
            display: inline-block; width: 265px; padding-bottom: 24px; margin-bottom: 40px;
            margin-right: 42px;
            border: 1px solid #E6E6E6;
            .imgBox{
                position: relative;  
                .listImg{
                    width: 265px;
                    height: 265px; display: block;
                }
                .tagBox{
                    position: absolute;right:0; bottom:6px;
                    .flowerTag{display: inline-block; margin-right: 8px;
                        width: 48px; text-align: center;
                        height: 24px;
                        background: #3F33FF;
                        border-radius: 2px;
                        font-size: 12px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 24px;
                    ;}
                    .blueTypeTag{}
                    .flowerTag.orangeTypeTag{
                        background: #FAAD14;
                    }
                    .flowerTag.greenTypeTag{
                        background: #4CD964;
                    }
                }
            }
            .titleLine{
                margin-top:16px;margin-left:8px;
                font-size: 14px;
                font-weight: 400;
                color: #2A2E3F;
                line-height: 22px;
                width: 249px;
                
            }
            .titleLine.oneLineHeight{
                height: 22px;
                white-space: nowrap;
                overflow: hidden; 
                text-overflow: ellipsis;   
            }
            .titleLine.twoLineHeight{
                height: 44px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                  
                  
            }
            .subLine{
                margin-top:4px;margin-left:8px;
                height: 12px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 12px;
                
            }
            .priceLine{
                margin-top:16px;margin-left:8px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                .moneyIcon{color:#E11010;font-size: 16px;;}
                .moneyNumber{
                    color:#FF4D4F;font-size: 24px;;
                }
            }
        }
    }
 
    
</style>
